{
  "en": {
    "actions": {
      "hangarShare": {
        "enable": "Create share link",
        "rotate": "Rotate link",
        "disable": "Delete share link"
      },
      "announcements": {
        "addPart": "Add",
        "removePart": "Remove",
        "movePartUp": "Move up",
        "movePartDown": "Move down",
        "sendTest": "Send test",
        "publish": "Send",
        "retry": "Retry",
        "refreshEngagement": "Refresh counts",
        "openPost": "Open post"
      },
      "admin": {
        "dashboard": {
          "reloadModels": "Reload Models",
          "reloadScData": "Reload SC Data",
          "reloadPaints": "Reload Paints",
          "reloadModules": "Reload Modules",
          "reloadLoaners": "Reload Loaners"
        },
        "supporterContributions": {
          "syncFromPatreon": "Sync from Patreon",
          "markAnonymousSelected": "Mark selected as anonymous",
          "markPublicSelected": "Mark selected as public",
          "setSourceSelected": "Set source for selected",
          "destroySelected": "Delete selected"
        },
        "imports": {
          "loadAll": "Load all",
          "load": "Load",
          "loadScData": "Load SC data",
          "loadShipMatrix": "Load ship matrix",
          "cleanup": "Mark as failed",
          "cleanupSelected": "Mark selected as failed"
        }
      },
      "duplicate": "Duplicate",
      "upgrade": "Update available!",
      "backToHome": "Plot new course",
      "disableGrouping": "Disable Grouping",
      "enableGrouping": "Enable Grouping",
      "groupedByModel": "Grouped by Model",
      "destroyAccount": "Destroy Account",
      "saveScreenshot": "Save as PNG",
      "resolve": "Resolve",
      "sortBy": "Sort by",
      "back": "Back",
      "open": "Open",
      "copy": "Copy",
      "download": "Download",
      "zoom": "Zoom",
      "viewImage": "View %{name} full size",
      "more": "More...",
      "export": "Export",
      "exportHangarLink": "Export for hangar.link",
      "import": "Import",
      "here": "here",
      "previous": "Previous",
      "next": "Next",
      "cancel": "Cancel",
      "ok": "Ok",
      "reset": "Reset",
      "reload": "Reload",
      "retry": "Try Again",
      "confirm": "Confirm",
      "showDetailPage": "Detail Page",
      "showDetails": "Show Details",
      "hideDetails": "Hide Details",
      "showPledgeValue": "Show Pledge Value",
      "showInGameBoughtValue": "Show In-Game Bought Value",
      "readMore": "Read more",
      "readLess": "Show less",
      "showGuide": "Show tour",
      "tour": {
        "next": "Next",
        "back": "Back",
        "skip": "Skip tour",
        "done": "Done"
      },
      "showFleetchart": "Fleetchart",
      "hideFleetchart": "Default view",
      "fleetchartApp": {
        "useExtendedState": "Show ships in extended state",
        "useRetractedState": "Show ships in flight"
      },
      "showLabels": "Show Labels",
      "hideLabels": "Hide Labels",
      "resetZoom": "Reset Zoom",
      "supportUs": "Support FleetYards.net",
      "appUpdate": {
        "reload": "Reload",
        "whatsNew": "What's new"
      },
      "installApp": {
        "cta": "Install app",
        "later": "Not now"
      },
      "supportHint": {
        "cta": "Support FleetYards",
        "later": "Maybe later"
      },
      "login": "Login",
      "signUp": "Sign Up",
      "confirmAccess": "Confirm password",
      "sendConfirmAccessEmail": "Send confirmation email",
      "reset-password": "Forgot password?",
      "edit": "Edit",
      "clear": "Clear",
      "done": "Done",
      "share": "Share",
      "change": "Change",
      "upload": "Upload",
      "save": "Save",
      "enable": "Enable",
      "disable": "Disable",
      "manage": "Manage",
      "enableGlobally": "Enable Globally",
      "disableGlobally": "Disable Globally",
      "addActor": "Add Actor",
      "addGroup": "Add Group",
      "editGroup": "Edit Group",
      "remove": "Remove",
      "reorder": "Reorder",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "delete": "Delete",
      "deleteSelected": "Delete Selected",
      "enableSelected": "Enable Selected",
      "disableSelected": "Disable Selected",
      "presets": {
        "choose": "Choose an image",
        "remove": "Remove image"
      },
      "close": "Close",
      "filter": "Filter",
      "showStatusColor": "Show Status as Color",
      "hideStatusColor": "Hide Status as Color",
      "addToHangar": "Add to Hangar",
      "blueprint": {
        "apply": "Apply",
        "discard": "Discard",
        "removeCrafting": "Remove crafting",
        "own": "Mark as owned",
        "unown": "Remove owned mark",
        "unwant": "Remove from Wishlist"
      },
      "resetFilter": "Reset Filter",
      "requestPassword": "Request Password email",
      "changePassword": "Change Password",
      "updatePassword": "Update Password",
      "copyBackupCodes": "Copy Backup Codes",
      "regenerate": "Regenerate",
      "add": "Add",
      "create": "Create",
      "addToWishlist": "Add to Wishlist",
      "addVehicle": "Add Ships",
      "showTableView": "List",
      "showGridView": "Grid",
      "linkExisting": "Link Existing",
      "loadMore": "Load more",
      "unlink": "Unlink",
      "syncRsiBuybacks": "Sync RSI Buy-Backs",
      "syncRsiHangar": "Sync RSI Hangar",
      "oauthApplications": {
        "create": "New Application",
        "regenerateSecret": "Regenerate Secret",
        "approve": "Approve",
        "reject": "Refuse",
        "rejectSelected": "Refuse selected"
      },
      "oauthAuthorize": {
        "authorize": "Authorize",
        "deny": "Deny"
      },
      "verifyWithCitizenId": "Verify with Citizen iD",
      "user": {
        "rsiVerification": {
          "verify": "Verify via RSI profile",
          "check": "Check now",
          "checkIn": "Check again in %{seconds}s",
          "copyToken": "Copy token",
          "regenerateToken": "Generate new token",
          "revoke": "Revoke"
        }
      },
      "oauth": {
        "signInWith": "Sign in with",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "Connected to Google",
          "discord": "Connected to Discord",
          "bluesky": "Connected to BlueSky",
          "github": "Connected to GitHub",
          "twitch": "Connected to Twitch",
          "citizenid": "Connected to Citizen iD",
          "patreon": "Connected to Patreon"
        },
        "disconnect": {
          "google": "Disconnect Google",
          "discord": "Disconnect Discord",
          "bluesky": "Disconnect BlueSky",
          "github": "Disconnect GitHub",
          "twitch": "Disconnect Twitch",
          "citizenid": "Disconnect Citizen iD",
          "patreon": "Disconnect Patreon"
        },
        "patreon": "Patreon"
      },
      "compare": {
        "ships": "Compare",
        "item": "Compare"
      },
      "cargoGrids": {
        "addShips": "Add Ships"
      },
      "tradeRoutes": {
        "pickShip": "Pick a ship",
        "changeShip": "Change ship",
        "editRun": "Edit",
        "doneEditing": "Done",
        "backToRuns": "Back to all runs",
        "showMore": "Show more runs"
      },
      "hangar": {
        "editGroups": "Add or remove Groups",
        "editName": "Name your Ship",
        "manageLoadouts": "Manage Loadouts",
        "manageCargo": "Manage Cargo",
        "useName": "Use Name",
        "destroyAll": "Remove all Ships",
        "showOnPublicHangar": "Make Public",
        "hideFromPublicHangar": "Hide from Public",
        "editGroupsSelected": "Add/Remove from Groups",
        "hideFromHangar": "Hide from Hangar",
        "showInHangar": "Show in Hangar",
        "resetIngame": {
          "openModal": "Reset Ingame Ships after Wipe",
          "moveToWishlist": "Move to Wishlist",
          "removeAll": "Remove all"
        },
        "editLoadout": "Edit loadout"
      },
      "syncExtension": {
        "cancel": "Cancel",
        "start": "Start Sync",
        "retry": "Retry Sync",
        "runInBackground": "Continue in background",
        "showResult": "Show Result",
        "close": "Close",
        "refresh": "Refresh Page",
        "checkAgain": "Check again",
        "addExtension": "Add",
        "updateExtension": "Update",
        "change": "Change"
      },
      "empty": {
        "hangarGuide": "Take the tour",
        "reset": "Clear Filters"
      },
      "destroyFleet": "Destroy Fleet",
      "restore": "Restore",
      "fleet": {
        "fidClaim": {
          "claim": "Claim %{fid}",
          "withdraw": "Withdraw claim",
          "useSuggestion": "Use %{suggestion}",
          "endNow": "End grace period now",
          "cancel": "Cancel claim"
        },
        "rsiVerification": {
          "verify": "Verify",
          "regenerateToken": "Generate new token",
          "check": "Check now",
          "copyToken": "Copy token",
          "revoke": "Revoke"
        },
        "join": "Join %{fleet}!",
        "leave": "Leave %{fleet}",
        "createInviteUrl": "Create Invite Urls",
        "inviteMember": "Invite new Member",
        "squadrons": {
          "create": "Create Squadron",
          "addMember": "Add Members",
          "removeMember": "Remove from squadron",
          "addMembers": "Add %{count}",
          "viewMembers": "Squadron members",
          "viewShips": "Squadron ships",
          "viewStats": "Squadron stats",
          "join": "Join team",
          "leave": "Leave",
          "requestJoin": "Request to join",
          "withdrawRequest": "Withdraw request",
          "acceptRequest": "Accept",
          "declineRequest": "Decline",
          "promote": "Promote",
          "demote": "Demote"
        },
        "manageInvites": "Invites",
        "worldmap": "Worldmap",
        "starmap": "Starmap",
        "acceptInvite": "Accept Invitation",
        "declineInvite": "Decline Invitation",
        "withdrawRequest": "Withdraw Request",
        "acceptRequest": "accept Request",
        "declineRequest": "Decline Request",
        "members": {
          "invite": "Invite",
          "promote": "Promote",
          "demote": "Demote",
          "accept": "Accept",
          "decline": "Decline",
          "remove": "Remove",
          "editRole": "Edit Role",
          "editNickname": "Edit Nickname",
          "health": {
            "open": "Member health",
            "showAll": "Show all %{count}",
            "inviteLinks": "Invite links",
            "discordSettings": "Discord settings",
            "verifyOrg": "Verify the RSI organisation",
            "remove": "Remove from fleet",
            "revoke": "Revoke invitation",
            "deleteLink": "Delete link",
            "promoteTo": "Promote to %{role}",
            "addToSquadron": "Add to squadron",
            "addToNamedSquadron": "Add to %{squadron}",
            "addMembers": "Add members",
            "deleteSquadron": "Disband",
            "remind": "Remind to verify"
          }
        },
        "inviteUrls": {
          "create": "Create new Invite Url"
        },
        "discord": {
          "test": "Test Discord connection",
          "installBot": "Install the Fleetyards bot in your Discord server"
        },
        "calendarSubscription": {
          "enable": "Generate subscription link",
          "rotate": "Rotate link",
          "disable": "Disable subscription"
        }
      },
      "model": {
        "gallery": "Gallery",
        "onSale": "On Sale: %{price}",
        "store": "RSI Page",
        "showViews": "All views",
        "hideViews": "Fewer views"
      },
      "itemViews": {
        "sync": "Sync Views"
      },
      "models": {
        "sync": "Sync from RSI",
        "syncMatrix": "Sync Matrix",
        "syncScData": "Sync SC Data",
        "importPaints": "Import Paints",
        "syncShipViews": "Sync Ship Views",
        "exchangeStoreImage": "Use RSI Image",
        "images": "Images",
        "openTableConfiguration": "Open Table Configuration"
      },
      "users": {
        "loginAs": "Login as User",
        "resendConfirmation": "Resend Confirmation",
        "sendPasswordReset": "Send Password Reset"
      },
      "unselect": "Unselect all Selected",
      "twoFactor": {
        "enable": "Enable Two-factor",
        "disable": "Disable Two-factor",
        "generateBackupCodes": "Generate Backup Codes"
      },
      "holoViewer": {
        "loadAnyway": "Load anyway",
        "autoRotate": {
          "enable": "Enable auto rotate",
          "disable": "Disable auto rotate"
        },
        "zoom": {
          "enable": "Enable zoom",
          "disable": "Disable zoom"
        },
        "color": {
          "enable": "Enable colors",
          "disable": "Disable colors"
        },
        "grid": {
          "enable": "Show grid",
          "disable": "Hide grid"
        }
      },
      "logistics": {
        "addToInventory": "Add to Inventory",
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "Clear Cargo",
        "viewCargoGrid": "View Cargo Grid",
        "sendTransfer": "Send",
        "moveStock": "Move",
        "transfer": "Transfer",
        "acceptTransfer": "Accept",
        "declineTransfer": "Decline",
        "cancelTransfer": "Cancel",
        "reportTransfer": "Report",
        "resetToMax": "Reset to maximum",
        "removeLine": "Remove"
      },
      "adminNotifications": {
        "read": "Mark as read",
        "unread": "Mark as unread",
        "archive": "Archive",
        "unarchive": "Move back to inbox",
        "readAll": "Mark all as read",
        "destroyAll": "Delete all",
        "sortOldest": "Oldest first",
        "sortNewest": "Newest first",
        "select": "Select notification",
        "readSelected": "Mark selected as read",
        "unreadSelected": "Mark selected as unread",
        "archiveSelected": "Archive selected",
        "unarchiveSelected": "Move selected back to inbox",
        "destroySelected": "Delete selected"
      },
      "account": {
        "calendarSubscription": {
          "enable": "Generate personal calendar link",
          "rotate": "Rotate link",
          "disable": "Disable subscription"
        }
      },
      "today": "Today",
      "fleets": {
        "missions": {
          "publish": "Publish",
          "create": "Create Mission",
          "edit": "Edit Mission",
          "archive": "Archive Mission",
          "unarchive": "Unarchive",
          "destroy": "Delete Permanently",
          "addTeam": "Add Team",
          "addShip": "Add Ship",
          "addSlot": "Add Slot",
          "viewMissions": "View Missions"
        },
        "tours": {
          "viewTours": "View Tours"
        },
        "events": {
          "create": "Create Event",
          "edit": "Edit Event",
          "spawn": "Spawn from this Mission",
          "archive": "Archive Event",
          "unarchive": "Restore from archive",
          "syncToDiscord": "Sync to Discord",
          "destroy": "Delete Permanently",
          "publish": "Publish",
          "lockSignups": "Lock signups",
          "unlockSignups": "Unlock signups",
          "start": "Start",
          "complete": "Complete",
          "cancel": "Cancel",
          "signup": "Sign up",
          "withdraw": "Withdraw",
          "kick": "Remove signup",
          "addToCalendar": "Add to calendar",
          "subscribe": "Subscribe",
          "setUpCalendar": "Set up calendar subscriptions",
          "assignSlot": "Assign to slot",
          "reassignSlot": "Move to another slot",
          "manageEventTeam": "Manage event team",
          "grantRole": "Grant role",
          "revokeRole": "Revoke",
          "addTeam": "Add team"
        },
        "contracts": {
          "create": "Create Contract",
          "save": "Save Contract",
          "publish": "Publish",
          "claim": "Claim",
          "join": "Ask to join",
          "release": "Give up",
          "fulfil": "Mark fulfilled",
          "cancel": "Cancel Contract",
          "edit": "Edit",
          "leave": "Leave",
          "remove": "Remove",
          "acceptCrew": "Accept",
          "declineCrew": "Decline",
          "addItem": "Add goods",
          "payouts": "Payouts"
        }
      },
      "notifications": {
        "read": "Mark as read",
        "unread": "Mark as unread",
        "archive": "Archive",
        "unarchive": "Move back to inbox",
        "readAll": "Mark all as read",
        "destroyAll": "Delete all",
        "settings": "Notification settings",
        "sortOldest": "Oldest first",
        "sortNewest": "Newest first",
        "openCenter": "Notifications",
        "pushEnable": "Turn on for this device",
        "pushDisable": "Turn off for this device",
        "pushRemove": "Remove",
        "select": "Select notification",
        "readSelected": "Mark selected as read",
        "unreadSelected": "Mark selected as unread",
        "archiveSelected": "Archive selected",
        "unarchiveSelected": "Move selected back to inbox",
        "destroySelected": "Delete selected"
      },
      "unlistedModel": {
        "createModel": "Create ship",
        "markAsPaint": "It is a paint",
        "ignore": "Ignore",
        "noManufacturer": "No manufacturer resolves from this identifier",
        "alreadyExists": "%{name} is already in the catalogue",
        "link": "Already in the catalogue",
        "markAsPaintSelected": "Mark selected as paints",
        "ignoreSelected": "Ignore selected"
      },
      "revert": "Revert",
      "exportCsv": "Export CSV",
      "exportAllCsv": "Export all as CSV",
      "imports": {
        "cancel": "Cancel",
        "downloadExample": "Example file",
        "toggleDetails": "Show what happened"
      },
      "selectFile": "Select File",
      "applyGameFileValue": "Apply",
      "applyAllGameFileValues": "Apply all",
      "payouts": {
        "archiveTour": "Archive",
        "unarchiveTour": "Restore",
        "deleteTour": "Delete",
        "openLedger": "Open payout ledger",
        "addEntry": "Record money",
        "addParticipant": "Add participant",
        "settle": "Settle & calculate payouts",
        "reopen": "Reopen",
        "confirm": "Mark as paid",
        "unconfirm": "Mark as unpaid",
        "createTour": "Create Tour",
        "joinTour": "Join Tour",
        "rotateInvite": "Generate a new link",
        "askToJoin": "Ask to participate",
        "withdrawJoinRequest": "Withdraw request",
        "approveJoinRequest": "Approve",
        "declineJoinRequest": "Decline",
        "approveExpense": "Approve",
        "declineExpense": "Decline"
      },
      "relationships": {
        "accept": "Accept",
        "decline": "Decline",
        "ignore": "Ignore",
        "withdraw": "Withdraw",
        "end": "Remove",
        "send": "Send request",
        "user": {
          "add": "Add friend"
        },
        "fleet": {
          "add": "Add ally"
        }
      },
      "supporterNomination": {
        "change": "Change fleet"
      },
      "vehiclePlaque": {
        "remove": "Remove plaque",
        "edit": "Edit plaque",
        "show": "Show dedication plaque"
      },
      "vehicleOverview": {
        "open": "Overview",
        "uploadPicture": "Upload a picture",
        "changePicture": "Change picture",
        "edit": "Edit ship",
        "shipDatabase": "Ship database",
        "openLog": "Open the log",
        "applyPaint": "Apply %{paint}",
        "editPaints": "Edit paints",
        "editLocation": "Change location",
        "allPaints": "All %{count} paints",
        "fullscreenHolo": "Full screen",
        "allUpgrades": "All %{count} upgrades",
        "allBuybacks": "All %{count} buy-backs"
      },
      "vehicleLog": {
        "open": "Captain's Log",
        "add": "New entry",
        "showPublic": "Captain's Log"
      },
      "vehicleLoadout": {
        "craft": "Craft",
        "swapModule": "Swap module",
        "removeModule": "Remove module",
        "editLoadout": "Edit loadout",
        "newLoadout": "New loadout",
        "saveLoadout": "Save loadout",
        "saveAsNewLoadout": "Save as new loadout",
        "openLoadoutPage": "Open loadout page",
        "makePublic": "Make public",
        "makePrivate": "Make private",
        "linkInstead": "Link a build instead",
        "createOnFleetyards": "Create a loadout on Fleetyards",
        "viewLoadout": "View loadout",
        "hideFigures": "Hide figures",
        "showFigures": "Show figures"
      },
      "hangarPledgeItems": {
        "addToInventory": "Add to inventory",
        "addCount": {
          "one": "Add %{count} item",
          "other": "Add %{count} items"
        },
        "createInventory": "Create an inventory"
      },
      "plaqueTool": {
        "attach": "Save to hangar",
        "addShip": "Add %{model} to my hangar",
        "startFresh": "Start from scratch"
      }
    }
  }
}
